import { FC } from "react";

import { MessageBarType } from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { ClaimDataFetcher } from "@modules/acc/screens/shared-components/ClaimDataFetcher.tsx";
import { ErrorBlock } from "@ui-components/ErrorBlock.tsx";

interface Props {
  claimId: string;
  hideLink?: boolean;
}

export const ClaimAdjustmentLodgeError: FC<Props> = ({ claimId, hideLink }) => {
  const getErrorBlock = (
    errorText: string,
    referralIn?: boolean,
    errorStyle?: boolean
  ) => {
    const text = referralIn
      ? "Enter into referral information in summary card."
      : "Change status to incomplete in setup and update.";
    return (
      <ErrorBlock
        errorText={`${errorText} ${text}`}
        linkText={!hideLink ? "Update claim" : undefined}
        to={
          !hideLink
            ? routes.claims.management.edit.path({
                id: claimId
              })
            : undefined
        }
        errorType={errorStyle ? MessageBarType.error : MessageBarType.warning}
      />
    );
  };

  return (
    <ClaimDataFetcher claimId={claimId}>
      {claim => {
        if (!claim || (claim.accidentDate && claim.primaryDiagnosis)) {
          return null;
        }

        const accidentDateWarning =
          claim.isAcc32Allowed && !claim.accidentDate
            ? getErrorBlock(
                "Claim is missing injury date. This field is usually required for an ACC32 to get approved.",
                claim.referralIn,
                false
              )
            : null;

        const primaryDiagnosisError =
          claim.isAcc32Allowed && !claim.primaryDiagnosis
            ? getErrorBlock(
                "Claim must have a primary diagnosis to lodge an ACC32.",
                claim.referralIn,
                true
              )
            : null;
        return (
          <>
            {accidentDateWarning}
            {primaryDiagnosisError}
          </>
        );
      }}
    </ClaimDataFetcher>
  );
};
